export const VERSION = '4.77.0'; // x-release-please-version
